export default __webpack_public_path__ + "static/media/player-list-active.332cc153.svg";